const menuConfig = [
  {
    name: 'chainLocations',
    path: '/chain-locations',
    options: [
      {
        name: 'stores',
        path: '/stores',
      },
      {
        name: 'touchpoints',
        path: '/touchpoints',
      },
    ],
  },
  {
    name: 'touchpointDevices',
    path: '/touchpoint-devices',
    options: [
      {
        name: 'deviceTypes',
        path: '/device-types',
      },
      {
        name: 'devices',
        path: '/devices',
      },
    ],
  },
  {
    name: 'touchpointCategories',
    path: '/touchpoint-categories',
    options: [
      {
        name: 'touchpointApplications',
        path: '/touchpoint-applications',
      },
      {
        name: 'touchpointGroups',
        path: '/touchpoint-groups',
      },
    ],
  },
  {
    name: 'culture',
    path: '/culture',
    options: [
      {
        name: 'messages',
        path: '/messages',
      },
    ],
  },
  {
    name: 'general',
    path: '/general',
    options: [
      {
        name: 'reasonCodes',
        path: '/reason-codes',
      },
    ],
  },
  {
    name: 'businessDay',
    path: '/business-day',
    options: [
      // {
      //   name: 'manualApprovals',
      //   path: '/manual-approvals',
      // },
      // {
      //   name: 'businessPeriods',
      //   path: '/business-periods',
      // },
      {
        name: 'businessDayScheduler',
        path: '/business-day-scheduler',
      },
    ],
  },
  // {
  //   name: 'culture',
  //   path: '/culture',
  //   options: [
  //     {
  //       name: 'cultureSettings',
  //       path: '/culture-settings',
  //     },
  //   ],
  // },
];

export default menuConfig;
